import store from "@/stores";

interface UploadFileParams {
  host?: string;
  path: string;
  file: File;
  orgId: string;
  metaData?: Record<string, string>;
}

export const uploadFile = async ({
  host,
  path,
  file,
  orgId,
  metaData = {},
}: UploadFileParams): Promise<string | undefined> => {
  if (!file || !file.size) return;

  const token = store.state.auth.auth?.id_token || "";
  const requestHost = host || store.state.config.serviceUrl || "";

  const data = new FormData();
  data.append("file", file);
  data.append("org_id", orgId);
  for (const [key, value] of Object.entries(metaData)) {
    data.append(key, value as string);
  }

  const response = await fetch(`${requestHost}/${path}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: "POST",
    body: data,
  });
  const { fileID } = await response.json();

  // returning fileId
  return fileID;
};
